module.exports = __webpack_public_path__ + "1cf9b0fb1ea989c5f8cfa9c51a950470.MP3";